
<template>
  <div>
    <v-container class="pt-0">
      <span v-if="showHeader" class="headline">{{$t('faqs.title')}}</span>
      <v-row>
        <v-col cols="12">
          <faq-content/>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0">
      <advertising-content/>
    </v-container>
  </div>
</template>

<script>
import FaqContent from "@/components/content/FAQContent";
import AdvertisingContent from '../widgets/AdvertisingContent.vue';

export default {
  name: "FAQs",
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FaqContent,
    AdvertisingContent,
  },
};
</script>
